<div class="card">
  <div class="card-header">
    <span class="card-title">Modify Privileges</span>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col">
        <mat-form-field class="p-0" appearance="outline">
          <mat-label>Category</mat-label>
          <input
            [(ngModel)]="privilegeCategory"
            aria-label="category"
            matInput
            type="text"
            #typeInput
            (keyup)="changedCategory($event)"
            [matAutocomplete]="autoType"
            [disabled]="!!disableCategory"
          />
          <mat-autocomplete
            autoActiveFirstOption
            #autoType="matAutocomplete"
            (optionSelected)="selectedCategory($event.option.value.id)"
            #typeAutocomplete
            [displayWith]="displayObject"
          >
            <mat-option
              *ngFor="let elem of privilegeCategoriesFiltered"
              [value]="elem"
            >
              {{ elem.name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Privileges</mat-label>

          <mat-select [(value)]="selectedPrivilegeIds" multiple>
            <!-- Read-only chips when the select is closed -->
            <mat-select-trigger>
              <div class="chip-trigger">
                <ng-container *ngIf="selectedPrivilegeIds.length; else none">
                  <mat-chip
                    *ngFor="let id of selectedPrivilegeIds"
                    disabled
                    tabindex="-1"
                    aria-hidden="true"
                  >
                    {{ lookupName(id) }}
                  </mat-chip>
                </ng-container>
                <ng-template #none>None</ng-template>
              </div>
            </mat-select-trigger>

            <!-- Options in the panel -->
            <mat-option
              *ngFor="let p of privileges"
              [value]="p.id"
              (onSelectionChange)="optionToggled($event, p)"
            >
              {{ p.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- // <mat-form-field appearance="outline">
        //   <mat-label>Privileges</mat-label>
        //   <mat-select [(value)]="selectedPrivilegeIds" multiple>
        //     <mat-option
        //       *ngFor="let p of privileges"
        //       [value]="p.id"
        //       (onSelectionChange)="optionToggled($event, p)"
        //     >
        //       {{ p.name }}
        //     </mat-option>
        //   </mat-select>
        // </mat-form-field> -->
      </div>
    </div>
  </div>
  <div class="card-footer" matDialogActions align="center">
    <button mat-flat-button (click)="cancel()" color="warn">Cancel</button>
    <button mat-flat-button (click)="accept()" color="primary">Accept</button>
  </div>
</div>
